import { AnswerAssessmentItem } from "../../types";
import VerdictBadge from "./verdictBadge";
import VerdictIcon from "./verdictIcon";

/**
 * Props for a single answer assessment card.
 */
interface AssessmentCardProps {
  /** Answer assessment entry to render. */
  item: AnswerAssessmentItem;
}

/**
 * Single answer assessment row matching the Evaluation Engine design.
 *
 * @param props.item - Answer assessment entry
 */
const AssessmentCard = (props: AssessmentCardProps) => {
  const { item } = props;

  return (
    <div className="flex items-start gap-3 rounded-lg border border-primaryGray-15 bg-white px-4 py-3">
      <div className="mt-0.5 shrink-0">
        <VerdictIcon verdict={item.verdict} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-small font-bold leading-5 text-primaryGray-1">
          Q{item.q_idx}: {item.question}
        </p>
        <p className="mt-0.5 text-small font-normal leading-5 text-primaryGray-6">
          {item.answer}
        </p>
      </div>
      <VerdictBadge verdict={item.verdict} />
    </div>
  );
};

export default AssessmentCard;
